<template>
  <div class="goods-empty">
    <!-- 菜单栏（内嵌App时隐藏） -->
    <app-header :title="title" back-type="back-app" />
    <div class="goods-empty-image"></div>
    <div class="goods-empty-label">
      <span class="label">{{ label }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PoodsEmpty',
  data() {
    return {
      title: '友邻少年',
      label: '请联系您的班主任获取学习课程'
    }
  }
}
</script>

<style lang="scss" scoped>
.goods-empty-image {
  background: url('../../images/goods/goods-empty.png') no-repeat;
  background-size: 100% 100%;
  width: 200px;
  height: 200px;
  margin: 50px auto 0px auto;
}
.goods-empty-label {
  color: #666666;
  font-size: 20px;
  text-align: center;
}
</style>
